import React, { useState, useEffect } from "react";
import { setCookie } from "utilities/utilities";

import './FeedbackModal.light.scss';
import './FeedbackModal.dark.scss';

export function FeedbackModal(props: {
  isAssistantPresent?: boolean;
  feedbackCookieName: string;
  closeModal: () => void;
}) {
  const SURVEY_LINK = "https://forms.office.com/g/Ndw874rq8q";
  const [hideSurveyOnStart, setHideSurveyOnStart] = useState(false);

  useEffect(() => {
    setCookie({ name: props.feedbackCookieName, value: hideSurveyOnStart });
  }, [hideSurveyOnStart]);

  const handleTakeSurvey = () => {
    window.open(SURVEY_LINK, '_blank');
    handleClose();
  };

  const handleClose = () => {
    props.closeModal();
  };

  const toggleHideSurveyOnStart = () => {
    setHideSurveyOnStart((prev) => !prev);
  };

  return (
    <div className={`feedback-container ${props.isAssistantPresent ? 'assistant-is-present' : ''}`}>
      <div className="close-button">
        <span
          className="material-icons"
          onClick={handleClose}>close</span>
      </div>
      <h2>We value your feedback!</h2>
      <p>
        Your opinion is important to us. Help us improve the Model Selection Platform (MSP) by answering a few questions.
      </p>
      <p>
        It should only take 5-10 minutes and responses are kept confidential.
      </p>
      <div className="do-not-remind-container">
        <input
          type="checkbox"
          id="doNotRemind"
          name="doNotRemind"
          checked={hideSurveyOnStart}
          onChange={toggleHideSurveyOnStart} />
        <label htmlFor="doNotRemind">
          Don&apos;t ask me again
        </label>
      </div>
      <div className="buttons">
        <span
          className="close"
          onClick={handleClose}>
          NO THANKS
        </span>
        <span
          className="primary"
          onClick={handleTakeSurvey}>
          TAKE SURVEY
        </span>
      </div>
    </div>
  );
}

export default FeedbackModal;
